// remove  site-main-contents class from main tag to solve the header overlapping  issue when home page banner no added
const sectionElement = document.querySelectorAll(".section");
const parentElement = document.querySelector('.site-main')

for(i = 0 ; i< sectionElement.length; i++){
    if(sectionElement[i].classList.contains('section-banner')){
        parentElement.classList.remove('site-main--contents');
    }
}